import { ILinkedScriptExecuteBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean } from "../../../beans";
import { IObjectBeanScriptExecutable } from "../../../beans/objects";
import { ScriptExecuteBehaviorTranslator } from "./ScriptExecuteBehaviorTranslator";
import { ObjectReferencesTranslator } from "./ObjectReferencesTranslator";
import { LinkedPageObjectTranslator } from "./LinkedPageObjectTranslator";

export class LinkedScriptExecuteBehaviorTranslator {
  from(bean: IXElementContentsObjectBean & IObjectBeanScriptExecutable): ILinkedScriptExecuteBehavior {
    const result = this.script.from(bean) as ILinkedScriptExecuteBehavior;
    result.references = this.references.from(bean).references;
    return result;
  }

  to(object: ILinkedScriptExecuteBehavior) {
    const result = this.script.to(object) as any;
    result.references = this.references.to(object);
    return result;
  }

  private readonly script = new ScriptExecuteBehaviorTranslator();
  private readonly references = new ObjectReferencesTranslator("script-link-input", new LinkedPageObjectTranslator());
}
